import { type Session } from "@src/appV2/Auth/types";
import { type Location } from "history";

import { logSidebarMenuItemClicked } from "./logSidebarMenuItemClicked";
import { type NavigationItem } from "./navigationMenu/types";

interface SidebarClickContext {
  isAdmin: boolean;
  session: Session;
  previousLocation: Location;
}

export function instrumentNavigationItem(
  item: NavigationItem,
  context: SidebarClickContext
): NavigationItem {
  return {
    ...item,
    onClick: () => {
      if (!context.isAdmin) {
        logSidebarMenuItemClicked({
          menuItemName: item.label,
          session: context.session,
          previousLocation: context.previousLocation,
        });
      }
      item.onClick?.();
    },
  };
}
